









import { Component, Vue } from "vue-property-decorator";

@Component
export default class ThreeFabricDisclaimer extends Vue {
  protected readonly disclaimerIcon = require("@/assets/images/disclaimer-icon.svg");
}
